import {
  GameLock,
  LockLocationType,
  LOCK_SOLUTION_SEPARATOR,
  EMPTY_LOCATION_ITEM,
} from '../../../../_models/Game';
import { Tag } from '../../../../_models/Tag';

const getLockById = (locks: GameLock[], id: string, type: LockLocationType) => {
  const lock = locks.find(
    (l: GameLock) => (l.locationItem === id || l.solution?.includes(id)) && l.locationType === type,
  );
  if (!lock) {
    return locks.find((l: GameLock) => {
      return (
        l.locationItem === EMPTY_LOCATION_ITEM &&
        l.locationType === type &&
        l.solution?.split(LOCK_SOLUTION_SEPARATOR).indexOf(`${id}`) >= 0
      );
    });
  }
  return lock;
};

export const getLockByPolygonId = (locks: GameLock[], polygonId: number): GameLock | undefined =>
  getLockById(locks, String(polygonId), LockLocationType.TransparentBox);

export const getLockByTagId = (locks: GameLock[], tagId: string): GameLock | undefined =>
  getLockById(locks, tagId, LockLocationType.Tag);

export const getTagByLockLocationItem = (
  tags: Map<string, Tag>,
  locationItem: string,
): Tag | null => {
  let tag = null;
  if (tags && tags.size) {
    tags.forEach((value) => {
      const sid = value.defaultSid || value.sid;
      if (sid === locationItem) {
        tag = value;
      }
    });
  }
  return tag;
};
